import {Link, useNavigate} from "react-router-dom";
import {Logo} from "../../base/Logo";
import {User, Shield} from "lucide-react";
import {LogoutButton} from "./LogoutButton";
import React from "react";
import {Balance} from "./Balance";
import {useAuth} from "../../../context";

export function Header() {
    const navigate = useNavigate();
    const { isAdmin } = useAuth();

    return (
        <nav className="bg-white shadow-sm">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex">
                        <Link to="/panel" className="flex items-center">
                            <Logo textColorClassName="text-gray-900" />
                        </Link>

                        <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
                            <button
                                onClick={() => navigate('/panel/sessions')}
                                className="border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                            >
                                Sessions
                            </button>
                        </div>
                    </div>
                    <div className="flex items-center">
                        <div className="mr-4">
                            <Balance />
                        </div>
                        {isAdmin && (
                            <button
                                onClick={() => navigate('/admin')}
                                className="p-2 text-gray-400 hover:text-indigo-600 transition-colors"
                                title="Admin Panel"
                            >
                                <Shield className="h-6 w-6" />
                            </button>
                        )}
                        <button
                            onClick={() => navigate('/panel/profile')}
                            className="p-2 text-gray-400 hover:text-gray-500"
                        >
                            <User className="h-6 w-6" />
                        </button>

                        <LogoutButton />
                    </div>
                </div>
            </div>
        </nav>
    );
}